import { useEffect, useState } from 'react';
import fnc from '../mymod/commFunction';
import './HomeViewCountBadge.scss';

const VIEW_COUNT_LABEL = '\uC870\uD68C\uC218';
const VIEW_COUNT_SUFFIX = '\uD68C';
const VIEW_COUNT_REFRESH_LABEL = '\uC0C8\uB85C\uACE0\uCE68';

const HomeViewCountBadge = ({ className = '' }) => {
  const [viewCount, setViewCount] = useState(0);
  const [isRefreshingViewCount, setIsRefreshingViewCount] = useState(false);

  const setCountFromResponse = (res) => {
    if (res && Array.isArray(res) && res[0]) {
      setViewCount(Number(res[0].view_count) || 0);
    }
  };

  const refreshViewCount = () => {
    setIsRefreshingViewCount(true);
    fnc.sendAxios('/homePageRoutes/selectViewCount', { pageKey: 'home' }, (res) => {
      setCountFromResponse(res);
      setIsRefreshingViewCount(false);
    });
  };

  useEffect(() => {
    refreshViewCount();
  }, []);

  return (
    <div className={`home-view-count-wrap ${className}`.trim()}>
      <p className="home-view-count">{VIEW_COUNT_LABEL} {viewCount.toLocaleString()}{VIEW_COUNT_SUFFIX}</p>
      <button
        type="button"
        className={`home-view-refresh ${isRefreshingViewCount ? 'is-refreshing' : ''}`}
        onClick={refreshViewCount}
        disabled={isRefreshingViewCount}
      >
        {isRefreshingViewCount ? `${VIEW_COUNT_REFRESH_LABEL}...` : VIEW_COUNT_REFRESH_LABEL}
      </button>
    </div>
  );
};

export default HomeViewCountBadge;
